import { createListFilters } from 'app/components'

export type ProfissionaisFilters = {
  /** Nome do profissional (busca parcial). */
  nome: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<ProfissionaisFilters>({
  nome: '',
})
